import React, { useState, useEffect, useRef } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { lightTheme, fonts } from 'theme';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import Fade from '@material-ui/core/Fade';
import ChevronDownIcon from 'mdi-material-ui/ChevronDown';
import { Link } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import ListSubheader from '@material-ui/core/ListSubheader';

const DropdownArrow = styled(ChevronDownIcon)``;

const DropdownButton = styled(Button)`
  font-weight: 500;

  ${DropdownArrow} {
    width: 0.75em;
    height: 0.75em;
    opacity: ${props => (props.active ? 1 : 0.25)};
    transition: all 0.1s ease-in-out;
  }
`;

const SmallMenuItem = styled(MenuItem)`
  font-size: 12px;
`;

const MenuSubheader = styled(ListSubheader)`
  font-family: ${fonts.monoFamily};
  font-size: 0.65rem;
  line-height: 2rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.15em;
`;

const LegacyItem = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  .isvg {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-right: 8px;
    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

const Dropdown = ({ label, groups, legacyGroups, popperProps }) => {
  const location = useLocation();
  const anchorEl = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location]);

  const handleShow = () => {
    setOpen(true);
  };
  const handleHide = () => setOpen(false);

  return (
    <div onMouseEnter={handleShow} onMouseLeave={handleHide}>
      <DropdownButton size="small" buttonRef={anchorEl} active={open}>
        {label} <DropdownArrow />
      </DropdownButton>
      <Popper
        open={open}
        anchorEl={anchorEl.current}
        keepMounted
        transition
        disablePortal
        placement="bottom-start"
        style={{ display: open ? 'block' : 'none' }}
        {...popperProps}
      >
        {({ TransitionProps }) => (
          <MuiThemeProvider theme={lightTheme}>
            <Fade {...TransitionProps}>
              <Paper>
                {(groups || []).map((group, idx) => (
                  <MenuList
                    subheader={
                      group.heading ? (
                        <MenuSubheader>{group.heading}</MenuSubheader>
                      ) : null
                    }
                    dense
                    key={idx}
                  >
                    {group.items.map((item, idx) => (
                      <SmallMenuItem
                        to={item.external ? null : item.link.href}
                        href={item.external ? item.link.href : null}
                        component={item.external ? 'a' : Link}
                        key={idx}
                      >
                        {item.link.title}
                      </SmallMenuItem>
                    ))}
                  </MenuList>
                ))}
                {legacyGroups && (
                  <MenuList dense>
                    {legacyGroups.map((item, idx) => (
                      <SmallMenuItem
                        to={item.section_url}
                        component={Link}
                        key={idx}
                      >
                        <LegacyItem>
                          <SVG src={item.section_icon.url} />
                          <div>
                            {item.section_title}
                            <Typography variant="caption">
                              {item.subtitle}
                            </Typography>
                          </div>
                        </LegacyItem>
                      </SmallMenuItem>
                    ))}
                  </MenuList>
                )}
              </Paper>
            </Fade>
          </MuiThemeProvider>
        )}
      </Popper>
    </div>
  );
};

export default Dropdown;
